import { render, staticRenderFns } from "./VipForWx.vue?vue&type=template&id=2bd2e1f4&scoped=true"
import script from "./VipForWx.vue?vue&type=script&lang=js"
export * from "./VipForWx.vue?vue&type=script&lang=js"
import style0 from "./VipForWx.vue?vue&type=style&index=0&id=2bd2e1f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd2e1f4",
  null
  
)

export default component.exports